import ElementGroups from "@ext/markdown/core/element/ElementGroups";

const videoSchema = {
	group: `${ElementGroups.block} ${ElementGroups.listItemContent} ${ElementGroups.galleryItem}`,
	draggable: true,
	attrs: {
		title: { default: null },
		path: { default: null },
		isLink: { default: true },
		scale: { default: null },
	},
};

export default videoSchema;
